import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { CouponTabState } from '@/types';

import type { SportCouponState } from './types';

const initialState: SportCouponState = {
  showMobileCoupon: false,
  showCouponPreview: false,
  isCouponSumChanged: false,
  couponTab: { active: 'coupon', disabled: null },
};

export const sportCouponSlice = createSlice({
  name: 'sportCoupon',
  initialState,
  reducers: {
    setShowMobileCoupon(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        showMobileCoupon: action.payload,
      };
    },
    setShowPreviewCoupon(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        showCouponPreview: action.payload,
      };
    },
    setCouponTab(state, action: PayloadAction<CouponTabState>) {
      return {
        ...state,
        couponTab: action.payload,
      };
    },
    setIsCouponSumChanged(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        isCouponSumChanged: action.payload,
      };
    },
  },
});

export const { setShowMobileCoupon, setShowPreviewCoupon, setCouponTab, setIsCouponSumChanged } =
  sportCouponSlice.actions;
